(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["corporate-gifting-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.corporate-gifting-csv-download');
    if (!button) return;

    const rows = [
      ['First name', 'Last name', 'Address line 1', 'Address line 2', 'City', 'State', 'ZIP code', 'Country', 'Gift option', 'Gift message'],
      ['Sample', 'Recipient', '123 Main Street', 'Suite 100', 'Fort Wayne', 'IN', '46802', 'USA', 'To be selected', 'Thank you from the whole team!']
    ];
    const csv = rows.map((row) => row.map((cell) => `"${cell.replaceAll('"', '""')}"`).join(',')).join('\n');
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'electric-sweets-corporate-gifting-template.csv';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  });

  } catch(e) { console.error(e); }
})();
})();
